import React, { useState } from "react";
import Checkbox from "../../components/checkbox";
import { PieceFilterAmountListElementData, PieceFilterAmountListElementInfo } from "./pieceFilterAmountListElement";

interface PieceFilterListProps {
    options: PieceFilterAmountListElementData[];
    fixed?: string[];
    active: PieceFilterAmountListElementData[];
    onUpdate: (active: PieceFilterAmountListElementData[]) => void;
    amount?: boolean;
    maxElements: number;
}

export default function PieceFilterList(props: PieceFilterListProps) {

    const [showAll, setShowAll] = useState(false);

    var count = 0;

    return <ul>
        {props.options.map(e => {
            if(count++ >= props.maxElements && !showAll) return;
            var activeEl = null;
            for(var i = 0; i < props.active.length; i++) {
                if(props.active[i].name === e.name) {
                    activeEl = props.active[i];
                }
            }
            return <Checkbox key={e.id} changeAmount={(v: number) => {
                var newActive = [...props.active];
                    for(var i = 0; i < newActive.length; i++) {
                        if(newActive[i].name === e.name) {
                            if(v <= 0) {
                                newActive.splice(i, 1);
                            }else {
                                newActive[i] = new PieceFilterAmountListElementData(e.name, v, e.id);
                            }
                        }
                    }
                    props.onUpdate(newActive);
            }} amount={activeEl?.amount} available={e.amount} value={activeEl != null} onClick={(v: boolean) => {
                if(v) {
                    props.onUpdate([...props.active, new PieceFilterAmountListElementData(e.name, 1, e.id)]);
                }else {
                    var newActive = [...props.active];
                    for(var i = 0; i < newActive.length; i++) {
                        if(newActive[i].name === e.name) {
                            newActive.splice(i, 1);
                        }
                    }
                    props.onUpdate(newActive);
                }
            }} label={<>
            {e.icon}
            {e.name}
            </>}/>;
        })}
        {props.options.length > props.maxElements ? <a onClick={() => {
            setShowAll(!showAll);
        }} className="grey show-all">{showAll ? "show less" : "show all"}</a> : <></>}
    </ul>
}